export enum ThemePreference {
    dark = "dark",
    light = "light",
    default = "default",
}